export amenity from './amenity/handlers';
export area from './area/handlers';
export blockedDateRange from './blocked-date-range/handlers';
export channel from './channel/handlers';
export synchronisation from './synchronisation/handlers';
export owner from './owner/handlers';
//export locality from './locality/handlers';
export property from './property/handlers';
export propertyGroup from './propertyGroup/handlers';
export zone from './zone/handlers';



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/handlers.js